import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';

import * as ActionCreators from '../../actions/ActionCreators';
import * as ActionTypes from '../../actions/ActionTypes';
import { serialize, handleErrors, isHLSSupported } from '../../utils/ASVPUtils';

import {
    UNSUPPORTED_CSS_CLASS,
    ERROR_FETCHING_SOURCE_SLATE,
    HLS_MIME_TYPE, VTT_MIME_TYPE,
    VIDEO_SOURCE_QUERY_PARAMS,
    VIDEO_SOURCE_URL
} from '../../constants';


const receiveVideoSourceEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.RECEIVE_VIDEO_SOURCE)
    .pluck('payload', 'video')
    .map(data => { // transform data
        const videoSourceData = {
            collectionTitle: data.collection_title,
            duration: data.duration,
            id: data.id,
            mimeType: '',
            poster: data.poster,
            title: data.title,
            titleId: data.title_id,
            type: data.type,
            contentURL: '',
            vttURL: ''
        };

        if (data.stream && data.stream.assets) {
            data.stream.assets.map((asset) => {
                if (asset.mime_type === HLS_MIME_TYPE && asset.url.indexOf('adultswim-ott') === -1) {
                    videoSourceData.contentURL = asset.url;
                    videoSourceData.mimeType = asset.mime_type;

                    // always use amd instead of ht
                    videoSourceData.contentURL = videoSourceData.contentURL.replace('ht.cdn.turner.com', 'amd.cdn.turner.com');
                    // always use https
                    videoSourceData.contentURL = videoSourceData.contentURL.replace('http://', 'https://');

                    return;
                }
            });

            data.stream.assets.map((asset) => {
                if (asset.mime_type === VTT_MIME_TYPE) {
                    videoSourceData.vttURL = asset.url;

                    return;
                }
            });
        }

        // if no stream attached to video but does have segments and at least one of them
        if (!data.stream || !data.stream.assets || !data.stream.assets.length && data.segments && data.segments.length) {
            data.segments[0].assets.map((asset) => {
                if (asset.mime_type === HLS_MIME_TYPE && asset.url.indexOf('adultswim-ott') === -1) {
                    videoSourceData.contentURL = asset.url;
                    videoSourceData.mimeType = asset.mime_type;

                    // always use amd instead of ht
                    videoSourceData.contentURL = videoSourceData.contentURL.replace('ht.cdn.turner.com', 'amd.cdn.turner.com');

                    // replace old turnerios url with new one
                    videoSourceData.contentURL = videoSourceData.contentURL.replace('turnerios-f.akamaihd.net/i/adultswim/big', 'adultswim-vh.akamaihd.net/i');

                    return;
                }
            });
        }

        return videoSourceData;
    })
    .map(data => ActionCreators.setVideoSource(data));


const setVideoSourceEpic = (action$, store, { player }) => Observable.merge(
        action$.ofType(ActionTypes.SET_VIDEO_SOURCE),
        action$.ofType(ActionTypes.ADS_PREROLL_END),
        action$.ofType(ActionTypes.ADS_MIDROLL_END),
        action$.ofType(ActionTypes.RECONNECT_STREAM),
    )
    .map(() => store.getState().videoSource) // get video source state from store
    .filter(videoSource => !!videoSource.contentURL)
    .do(videoSource => player.poster(videoSource.poster)) // set poster
    .do(videoSource => player.src({ 'type': videoSource.mimeType, 'src': videoSource.contentURL }))
    .do(() => (player.currentType() === HLS_MIME_TYPE && !isHLSSupported()) ? player.addClass(UNSUPPORTED_CSS_CLASS) : player.removeClass(UNSUPPORTED_CSS_CLASS)) // set/unset unsupported css class if can't play media
    .ignoreElements();


// when player is ready and/or video id is set -- fetch the data based on the videoID in the state
// the initial state might have the video id from how it's passed in on player creation (PLAYER_EVENT_READY)
// SET_VIDEO_ID will have set the video id to a new one.
const fetchVideoSourceEpic = (action$, store, { }) => Observable.merge(
        action$.ofType(ActionTypes.PLAYER_EVENT_READY),
        action$.ofType(ActionTypes.SET_VIDEO_ID)
    )
    .map(() => store.getState().player.videoID)
    .distinctUntilChanged() // stop here if the video id hasn't changed
    .filter(Boolean) // if video id exists
    .switchMap(videoID => Observable.fromPromise(
        fetch(`${VIDEO_SOURCE_URL}${videoID}?${serialize(VIDEO_SOURCE_QUERY_PARAMS)}`) // gets new video data from id
            .then(handleErrors)
            .then(res => res.json())
            .then(response => ActionCreators.receiveVideoSource(response.data))
            .catch(data => ActionCreators.fetchVideoSourceError(data))
    ));


// sets slate for video source error
const fetchVideoSourceError = (action$, store, { player }) => action$
    .ofType(ActionTypes.FETCH_VIDEO_SOURCE_ERROR)
    .do(data => console.log('fetchVideoSourceError', data))
    .do(() => player.pause()) // pause the content
    .do(() => player.poster(ERROR_FETCHING_SOURCE_SLATE))
    .ignoreElements();


export default combineEpics(
    fetchVideoSourceEpic,
    receiveVideoSourceEpic,
    fetchVideoSourceError,
    setVideoSourceEpic
);



// WEBPACK FOOTER //
// ./src/player/videoSource/epics.js